import React, { Component } from 'react';
import sectiondata from '../../data/sections.json';

class ServiceTwo extends Component {
  render() {
    const publicUrl = process.env.PUBLIC_URL + '/';
    const data = sectiondata.servicetwo;

    return (
      <div className="service-area service-area-about mg-top-70 pb-xl-5 pd-0">
        <div className="container">
          {/* <div className="section-title text-left">
            <h5 className="sub-title">{data.subtitle}</h5>
            <h2 className="title">{data.title}</h2>
            <p>{data.content1}</p> */}
          {/* </div> */}

          <div className="row justify-content-center">
            {[
              {
                title: "Off-Plan Property Sales",
                icon: "fa-building",
                points: [
                  "Exclusive access to projects from DAMAC, EMAAR, Sobha, Danube",
                  "Flexible payment plans",
                  "High appreciation potential",
                  "Early investor discounts"
                ]
              },
              {
                title: "Luxury Residential Sales",
                icon: "fa-house-chimney",
                points: [
                  "Penthouses in Downtown Dubai",
                  "Beachfront villas in Palm Jumeirah",
                  "Handpicked luxury properties",
                  "End-to-end closing support"
                ]
              },
              {
                title: "Real Estate Investment Advisory",
                icon: "fa-chart-line",
                points: [
                  "ROI projections",
                  "Risk analysis & market insights",
                  "Legal & tax guidance (via partners)"
                ]
              },
              {
                title: "End-to-End Buyer Support",
                icon: "fa-handshake",
                points: [
                  "Property selection & booking",
                  "Developer coordination",
                  "Payment tracking & handover"
                ]
              },
              {
                title: "International Client Services",
                icon: "fa-globe",
                points: [
                  "Virtual property tours",
                  "WhatsApp/video consultations",
                  "Legal coordination across countries"
                ]
              },
              {
                title: "After-Sales & Property Management",
                icon: "fa-people-carry-box",
                points: [
                  "Resale assistance & leasing",
                  "Tenant placement",
                  "Property maintenance (via partners)"
                ]
              }
            ].map((service, i) => (
              <div key={i} className="col-md-6 col-lg-4 mb-4">
                <div className="single-service-card h-100 text-center p-4 border rounded bg-white shadow-sm" style={{ borderRadius: '15px' }}>
                  <div className="thumb mb-3">
                    <i className={`fa ${service.icon} fa-3x`} style={{ color: "#FDA94F" }}></i>
                  </div>
                  <h5 className="mb-2">{service.title}</h5>
                  <ul className="text-start ps-3">
                    {service.points.map((point, j) => (
                      <li key={j} style={{ textAlign: 'left' }}>{point}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}

         
        

          
          </div>
        </div>
        </div>
      
    );
  }
}

export default ServiceTwo;
